import { CookieObject } from '@/hooks/CookieConsentContext';

export const isGoogleAnalyticsAccepted = (cookieObject?: CookieObject | null): boolean => {
  if (!cookieObject) {
    return false;
  }
  const consents = cookieObject.consents;
  return (consents && consents.googleAnalytics) || false;
};
